// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8816":"__federation_expose_DynamicChildViewWidget","9661":"__federation_expose_ImpactedRecordSelectorWidget"}[chunkId] + "." + {"8816":"abf37030","9661":"ce2122e3"}[chunkId] + ".chunk.css";
};